import {rpFeatureFlagPersonalizedHomepage} from "../../app/read_rp_environment_variables";
import {useIsAuthenticated} from "../../user/hooks/use_is_authenticated";
import {AuthenticatedHomepageView} from "./AuthenticatedHomepageView";
import {PublicHomepageView} from "./PublicHomepageView";

/** Authenticated users get the personalized composition; the public homepage stays untouched. */
export const HomepageView = () => {
    const isAuthenticated = useIsAuthenticated();

    return rpFeatureFlagPersonalizedHomepage && isAuthenticated ? <AuthenticatedHomepageView /> : <PublicHomepageView />;
};
import {rpFeatureFlagPersonalizedHomepage} from "../../app/read_rp_environment_variables";
import {useIsAuthenticated} from "../../user/hooks/use_is_authenticated";
import {AuthenticatedHomepageView} from "./AuthenticatedHomepageView";
import {PublicHomepageView} from "./PublicHomepageView";

/** Authenticated users get the personalized composition; the public homepage stays untouched. */
export const HomepageView = () => {
    const isAuthenticated = useIsAuthenticated();

    return rpFeatureFlagPersonalizedHomepage && isAuthenticated ? <AuthenticatedHomepageView /> : <PublicHomepageView />;
};
